import {Route, UrlMatcher, UrlSegment} from '@angular/router';
import {LayoutComponent} from 'app/layout/layout.component';
import {InitialDataResolver} from 'app/app.resolvers';
import { LoginGuard } from './shared/guard/login.guard';

const meetingMatcher: UrlMatcher = (segments) => {
  if (
    segments.length === 3 &&
    segments[2].path.match(/^(?:mr\..+|\d+r)$/i)
  ) {
    return {
      consumed: segments,
      posParams: {
        mainBody: segments[0],
        //body: segments[1],
        sessionID: segments[1],
        meetingNo: new UrlSegment(segments[2].path.replace(/^mr\./i, ''), {})
      }
    };
  }
  if (
    segments.length === 4 &&
    segments[3].path.match(/^(?:mr\..+|\d+r)$/i)
  ) {
    return {
      consumed: segments,
      posParams: {
        mainBody: segments[0],
        body: segments[1],
        sessionID: segments[2],
        meetingNo: new UrlSegment(segments[3].path.replace(/^mr\./i, ''), {})
      }
    };
  }
  return null;
};

const proposalMatcher: UrlMatcher = (segments) => {
  if (segments.length === 3 && ['A', 'a'].indexOf(segments[0].path) > -1) {

    return {
      consumed: segments,
      posParams: {
        body: segments[0],
        sessionID: segments[1],
        docNumber: segments[2]
      }
    };
  }
  if (segments.length === 4 && ['A', 'a'].indexOf(segments[0].path) > -1) {

    return {
      consumed: segments,
      posParams: {
        body: segments[1],
        sessionID: segments[2],
        docNumber: segments[3]
      }
    };
  }
  return null;
};


// @formatter:off
/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
export const appRoutes: Route[] = [
    {path: '', pathMatch : 'full', redirectTo: 'home-page'},

    {
        path       : '',
        component  : LayoutComponent,
        // resolve    : {
        //     initialData: InitialDataResolver,
        // },
        children   : [
            {path: 'login', loadChildren: () => import('app/modules/login/login.module').then(m => m.LoginModule)},
            {path: 'home-page', loadChildren: () => import('app/modules/home/home.module').then(m => m.HomeModule)},
            //{path: 'ga', loadChildren: () => import('app/modules/home/home.module').then(m => m.HomeModule)},
            //{path: 'ga', loadChildren: () => import('app/modules/ga/ga/ga.module').then(m => m.GaModule), data: {title: 'General Assembly'}},
            {path: 'a/dec', canActivate: [LoginGuard], loadChildren: () => import('app/modules/ga/ga/decisions/decisions.module').then(m => m.DecisionModule)},

            {path: 'ga', canActivate: [LoginGuard], loadChildren: () => import('app/modules/ga/ga/ga.module').then(m => m.GaModule)},
            {path: 'conferences', canActivate: [LoginGuard], loadChildren: () => import('app/modules/ga/ga/ga.module').then(m => m.GaModule)},

            {path: 'ga/c1', loadChildren: () => import('app/modules/ga/c1/c1.module').then(m => m.C1Module)},
            {path: 'ga/c2', loadChildren: () => import('app/modules/ga/c2/c2.module').then(m => m.C2Module)},
            {path: 'ga/c3', loadChildren: () => import('app/modules/ga/c3/c3.module').then(m => m.C3Module)},
            {path: 'ga/c4', loadChildren: () => import('app/modules/ga/c4/c4.module').then(m => m.C4Module)},
            {path: 'ga/wgsr', loadChildren: () => import('app/modules/ga/wgsr/wgsr.module').then(m => m.WgsrModule)},

            {path: 'items/:sessionID', loadChildren: () => import('app/modules/agenda-items/agenda-items.module').then(m => m.AgendaItemsModule)},
            {path: 'item/:agendaItemID', loadChildren: () => import('app/modules/agenda-item/agenda-item.module').then(m => m.AgendaItemModule)},
            {path: 'documents/:sessionID', loadChildren: () => import('app/modules/documents/documents.module').then(m => m.DocumentsModule)},
            {path: 'document/:documentID', loadChildren: () => import('app/modules/document/document.module').then(m => m.DocumentModule)},

            {path: 'schedule', loadChildren: () => import('app/modules/ga77_schedule/ga77_schedule.module').then(m => m.GA77ScheduleModule)},
            {path: 'agenda', loadChildren: () => import('app/modules/agenda-list/agenda-list.module').then(m => m.AgendaListModule)},

            {path: 'meetings/:sessionNo', loadChildren: () => import('app/modules/schedule-meeting/schedule-meeting.module').then(m => m.GA77ScheduleModule)},

            {path: 'A-i18n/:body/:sessionID/:docNumber', loadChildren: () => import('app/modules/proposal-details-i18n/proposal-details-i18n.module').then(m => m.ProposalDetailsI18nModule)},
            //{path: 'A/:sessionID/:docNumber', loadChildren: () => import('app/modules/proposal-details/proposal-details.module').then(m => m.ProposalDetailsModule)},
            {matcher: meetingMatcher,  loadChildren: () => import('app/modules/single-meeting/single-meeting.module').then(m => m.SingleMeetingModule)},
            {matcher: proposalMatcher,  loadChildren: () => import('app/modules/proposal-details/proposal-details.module').then(m => m.ProposalDetailsModule)},

            //{path: 'a/:body/:sessionID/:docNumber', loadChildren: () => import('app/modules/proposal-details/proposal-details.module').then(m => m.ProposalDetailsModule)},
            //{path: 'a/:body/:sessionID/:docNumber', loadChildren: () => import('app/modules/proposal-details/proposal-details.module').then(m => m.ProposalDetailsModule)},
            //{path: 'a/:body/:sessionID/:docNumber/:rev', loadChildren: () => import('app/modules/proposal-details/proposal-details.module').then(m => m.ProposalDetailsModule)},

            //{path: 'ecosoc', loadChildren: () => import('app/modules/ecosoc/ecosoc.module').then(m => m.EcosocModule),data :{ title:'ECOSOC'}},
            //{path: 'conferences', loadChildren: () => import('app/modules/conferences/conferences.module').then(m => m.ConferenceModule)},

            {path: ':body', canActivate: [LoginGuard], loadChildren: () => import('app/modules/ga/ga/ga.module').then(m => m.GaModule)},

        ]
    }
];
